import { createFileRoute } from '@tanstack/react-router';

import { StaffQueueView } from 'src/sections/staff/queue/queue-view';
import {
  DEFAULT_QUEUE_SORT,
  normalizeQueueSearch,
  DEFAULT_BRAND_REVIEW_FILTER,
} from 'src/sections/staff/queue/queue-views';

export const Route = createFileRoute('/w/queue')({
  // The reading of each field, legacy tab names included, lives beside the tabs
  // it names so it can be tested without mounting the route.
  validateSearch: normalizeQueueSearch,
  component: StaffQueuePage,
});

function StaffQueuePage() {
  const { view, show, clientId, engagementId, sort, reviews } = Route.useSearch();
  return (
    <StaffQueueView
      view={view}
      show={show}
      clientId={clientId}
      engagementId={engagementId}
      sort={sort ?? DEFAULT_QUEUE_SORT}
      reviewFilter={reviews ?? DEFAULT_BRAND_REVIEW_FILTER}
    />
  );
}
